// import { ReactComponent } from "bootstrap-icons/icons/layout-text-sidebar-reverse.svg";
import { MagicWand } from "@phosphor-icons/react";

export const AiTemplateIcon: typeof MagicWand = Object.assign(
  (props: any) => <MagicWand
    size={16}
    {...props}
  />,
  { $$typeof: MagicWand.$$typeof },
);
